module.exports = __webpack_public_path__ + "img/kx5200-char-3.a2437485.png";